var _circle, _path, _circle2;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgLatestEvent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20.6668,
    r: 20,
    fill: "#CED2E5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.0697 23.1838L20.2226 29.8921L14.9371 23.1422C14.9371 23.1422 14.9371 23.1422 14.937 23.1421C12.1529 19.5853 12.2476 15.4375 14.8061 12.9556C16.1858 11.6208 18.0604 10.8667 20.02 10.8667C21.9797 10.8667 23.8543 11.6209 25.2339 12.9557C26.7878 14.4631 27.2645 16.259 27.1059 18.0607C26.9491 19.8417 26.1666 21.628 25.156 23.0643L25.0697 23.1838Z",
    stroke: "black",
    strokeWidth: 1.73333
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.0013,
    cy: 17.7969,
    r: 2.46667,
    stroke: "black",
    strokeWidth: 1.73333
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLatestEvent);
export default __webpack_public_path__ + "static/media/latest-event.b8e2383f5289343211bfc65853790df8.svg";
export { ForwardRef as ReactComponent };